import { render, staticRenderFns } from "./AssetsLiabilitiesReadonlyTable.vue?vue&type=template&id=3c6107e2"
import script from "./AssetsLiabilitiesReadonlyTable.vue?vue&type=script&lang=js"
export * from "./AssetsLiabilitiesReadonlyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports